module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Chapter"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_84072-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_84072-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847674449_tableofcontents"
    }
  }, [_vm._v("1:")])]), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "href": "#/9781847674449_tableofcontents"
    }
  }, [_c('b', [_vm._v("THIS")]), _vm._v(" "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("IS A GOOD ROOM")]), _vm._v(".")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00001"
    }
  }, [_vm._v("It could be in Belgium, the U.S.A., Russia perhaps, Australia certainly, any land where a room can have wallpaper, carpet and curtains patterned with three different sorts of flower. Brown furniture covers most of the flowers. There isn’t much space between the wardrobe, the 1930s dressing-table, the chair with the tumbler of whisky on it, the double bed where I lie (not undressed yet) between a big carved Victorian headboard and footboard. There is also a modern washbasin, a nice bit of plumbing, the pipes sunk in the plaster instead of wriggling over it like in some rooms I’ve been. But there is no bible. All American hotel bedrooms have bibles so I am definitely not in the States. A pity. I hate feeling limited. I could be hundreds of men just now, a commercial traveller in wool or tweed, a farmer, an auctioneer, a tourist, one of those lecturers who appear in obscure halls to tell six middle-aged housewives and a retired police sergeant about the Impact of Van Gogh upon the Spotted Thrush during the Last Days of Pompeii. It does not matter how I earn my bread. The topic has ceased to sicken me, I don’t think about it. I am not being mysterious. Behind the bluebells on these curtains is the "), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("main street of a town that was fairly prosperous when these bedknobs were carved – Nairn, Kirkcaldy, Dumfries, Peebles. It is actually Peebles or Selkirk. If it is Selkirk, this is Wednesday. If it is Peebles I will be in Selkirk tomorrow night, Janine.")])]), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "layout flow-margin floatgalley-outside layoutwidth-auto",
    attrs: {
      "id": "rw-layout-flow-margin_84072-00001"
    }
  }, [_c('p', [_vm._v("2 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SOMEBODY PONDERS IN PEEBLES OR SELKIRK")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janine is worried and trying not to show it but she’s been trying not to show it for a long time, so though she wants her voice to sound casual it comes out husky when she says,")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00003"
    }
  }, [_vm._v("“How long till we get there?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00004"
    }
  }, [_vm._v("“About ten minutes,” says the driver, a fat well-dressed man who stop. Stop. I should undress first. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00002"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My problem is sex, not alcohol. I am certainly alcoholic, but not a drunkard. I never stagger or stammer, self-control is perfect, the work is not affected. It’s well-paid work, I needed an education to get it, but now I can do what is needed and even answer questions without thinking. Most work today can be done like that. If you lobotomised half the nation it would carry on as usual. The politicians do our thinking for us. No they don’t.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00006"
    }
  }, [_vm._v("“But Prime Minister, for the last twenty years the interest rate/inflation/unemployment/ homelessness/strikes/drunkenness/breakdown of social services/crime/death in police custody have been steadily increasing, how will you tackle this?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00007"
    }
  }, [_vm._v("“I’m glad you asked me that, Michael. We can’t change things overnight of course.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("No, the only people who need to think nowadays are in stock exchanges and the central committees of some eastern communist parties. Nobody lasts long in those organisations without a bit of active cunning. The rest of us do what we’re told and follow our leaders and so we should. What would happen if most people tried to act intelligently on their own behalf? Anarchy. Some trade unions try it. Read what the newspapers say about them. In Russia trade unions aren’t allowed. So what can we do with this intelligence we don’t need and can’t use? Stupefy it. Valium for housewives, glue-sniffing for schoolkids, hash for adolescents, rotgut South African wine for the unemployed, beer for the workers, spirits for me and the crowd I left downstairs ")]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("fifteen minutes ago. But when I try to remember that crowd  several loungebars come to mind, all with some wood-panelling, fake warmingpans, a door leading to a lobby leading to a street in Dundee or Perth or Peebles and all with people who say: ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00001"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("3 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MEN IN LOUNGE BARS AND WORRIED JANINE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_84072-00009"
    }
  }, [_vm._v("“And every month we have this searching approach to formal review.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00010"
    }
  }, [_vm._v("“Formal review?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00011"
    }
  }, [_vm._v("“Yes. Formal review.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00012"
    }
  }, [_vm._v("“You know the sort of man I am. I get an idea in the morning, I think it out in the afternoon. Next day I order the materials and the job’s done by the end of the week. And if someone gets in the way I push past them. I push right past them.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00013"
    }
  }, [_vm._v("“But you’re straight. You’re straight. People respect you for that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00014"
    }
  }, [_vm._v("“I don’t care what their religion is as long as they’re on the pill.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00015"
    }
  }, [_vm._v("“HAHAHAHAHA. HAHAHAHAHA.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00016"
    }
  }, [_vm._v("People who talk give themselves away all the time. I don’t talk. I stand listening until their voices become a cheerful noise and then I want privacy. I want my bed, and Janine. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00003"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Janine is worried and trying not to show it but she’s been trying not to show it for a long time so her voice is husky when she asks, “How long till we get there?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00018"
    }
  }, [_vm._v("“About ten minutes,” says the driver, a fat well-dressed man called Max who looks happier with every minute that passes. He takes a hand from the wheel and pats her thigh reassuringly. She winces, then after a moment says, “You told me that in the office before we left.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00019"
    }
  }, [_vm._v("“I’ve no idea of time, that’s my trouble. But don’t worry about me, worry about Hollis.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00020"
    }
  }, [_vm._v("“Why? Why should I worry about Hollis?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00021"
    }
  }, [_vm._v("“Hollis is the recreation officer and you want the job, yes? But don’t worry, you’ll get it all right. You’re dressed just right for Hollis.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00022"
    }
  }, [_vm._v("“My agent told me to dress this way.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00023"
    }
  }, [_vm._v("“Your agent reads Hollis like a book.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("But Janine is not happy about the white silk blouse shaped by the way it hangs from her I must "), _c('i', [_vm._v("not")]), _vm._v(" think about clothes ")]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("before I’ve imagined Janine herself. But clothes keep trying to come first. Do I like women’s clothes more than their bodies? Oh no, but I prefer their clothes to their minds. Their minds keep telling me, no thankyou, don’t touch, go away. Their clothes say, look at me, want me, I am exciting. It would be perverse not to prefer their clothes to their minds. A woman in the loungebar downstairs, not young but good-looking, had buttoned flaps on her breasts and thighs and buttocks which seemed to be inviting my hands to fumble and undo her all over. I like the clothes women wear nowadays. When I was young most girls wore bright skirts and frocks which, along with their size and hair and breasts and voices, made them seem like superior, more delicate animals. I prefer them dressing like cowboys and carpenters and soldiers. Jeans, dungarees, boots and combat trousers don’t look practical on them, but suggest they are ready to get down into the dirt with us men. I find that exciting. Some men, the unsuccessful lecherous kind (but we’re all that kind) get angry with women who dress excitingly and say they deserve whatever happens to them. Meaning rape, of course. I don’t agree though I know why they feel that way. They hate being excited by women they can’t possess. But real women don’t frustrate me because I have this dirty imagination. I have Janine, Superb, Big Momma and Helga. I also have a sense of justice. Yes, I need justice on my side. If Janine is going to deserve what happens to her she must do more than wear a silk shirt shaped by the way it hangs from her etcetera. Start earlier. ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00004"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00002"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("4 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THE CLOTHES OF WOMEN")])])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("Janine, barefoot, is slightly smaller than most women but in her shoes she is slightly taller than most men and can be read sexually from a great distance: slender waist, knees and wrists, plump hips and shoulders, big etcetera and dark, copious hair expensively disarranged. She is clever in a fragmentary way, bad at judging people but good at judging her effect on them. With make-up she can look like almost any female stereotype from the dumb adolescent to the cool aristocrat. Just now she looks like Jane Russell in a forties film, "), _c('i', [_vm._v("The Outlaw")]), _vm._v(": eyes dark and accusing, lips heavy and sullen. She looks sullenly across a desk at her agent who says ")]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("“Janine, you are wonderful when you keep your mouth  shut. You are great in parts where you don’t need to talk.  But you will never, never, never be an actress.” ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00003"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("5 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("SOME SEXUAL BLACKMAIL")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00002"
    }
  }, [_vm._v("She stares at him a little while longer then says in a low voice, “Last week you told me something different.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00026"
    }
  }, [_vm._v("“Last week my judgment was upset by your … obvious charms. I’m sorry.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00027"
    }
  }, [_vm._v("He shrugs his shoulders but doesn’t look very sorry. He offers a cigarette. She takes it but ignores his offered lighter, using instead a match from her handbag. She inhales carefully then says, “Yes we’ve done a lot of things together in the last few days. Your wife can’t have seen much of you, Charlie. How is she?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00028"
    }
  }, [_vm._v("“Janine, I have tried to get you work, you know I have. But who wants a talking actress whose voice has only one note?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00029"
    }
  }, [_vm._v("“I’m asking about your wife Charlie. The one you married three months ago, remember? Your second wife. How much alimony are you paying the first?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00030"
    }
  }, [_vm._v("“Listen, Janine, I’m your friend–”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00031"
    }
  }, [_vm._v("“I’m glad, Charlie,” she says, and names a sum of money. And adds, “Give me a cheque now so I can cash it before the banks shut. That will stop me phoning your wife for exactly one month. And if you don’t get me work that pays good money by the end of the month I’ll want another cheque for the same amount. Regard it as insurance against fresh alimony.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00032"
    }
  }, [_vm._v("She leaves his office with the cheque in her handbag. At the door he says heavily, “Janine, let me see you tonight.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "rw-p_84072-00033"
    }
  }, [_vm._v("“Why Charlie, you’re still interested in me, how sweet. But if you want call-girl service you’ll have to pay extra now, and you can’t afford it. So just you go home to your wife.” She is triumphant, this bad wee girl who certainly deserves a spanking. So does the agent, but he doesn’t interest me, he’s only there to make Janine believable. I was wrong when I said I needed justice on my side, all I need is revenge. On a woman. Revenge for what? The answer to that question has nothing to do with the pleasurable expansion of the penis. I refuse to remember my marriage. I will pour into the mouth of this head another dram of stupidity. The questioning part of this brain is too active tonight.")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00004"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("6 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("BALLS IMPACT ON FANTASY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My problem is sex, or if it isn’t, sex hides the problem so completely that I don’t know what it is. I want revenge on a woman who is not real. I know several real women and if they got near my lovely, punishable Janine they would shame me into rescuing her. When I was a boy I rescued her all the time, she mainly existed for that. When I had freed her from the Roman arena, the pirates or the Gestapo, she vanished. I couldn’t believe in her any more. She was a decent girl in those days, like the girls in my class at school, and I was decent too. But the balls sank into my scrotum, the wet dreams began, I gained a crude notion of what to put where, and now Janine has only one thing in common with the attractive women I know, she never stays long with me if she can leave. Apart from that she is fantastic: completely sexy and calculating and sure of herself. Real women can be sexy and calculating with a man, if they don’t love him, but they are never sure of themselves. Inside they are like me, terrified, which is why they need to grab things. When women or men give away affection or money, and give easily without an eye on the future, these people (who can be quite plain and unsexy) are for that moment completely sure of themselves. The fools probably feel they will never die. But I am making a world where Janine’s agent phones a day later and says in a bright, urgent voice,")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00003"
    }
  }, [_vm._v("“Would you like to meet a millionaire?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00004"
    }
  }, [_vm._v("“Tell me more, Charlie.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00005"
    }
  }, [_vm._v("“There’s a country-club just outside town, men-only membership, but respectable. And exclusive. Only big lawyers and property men can join, the kind who like to get away from the wife and kids now and then for a round of golf etcetera.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00006"
    }
  }, [_vm._v("“What does etcetera mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00007"
    }
  }, [_vm._v("“Sauna, massage and good meal.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00008"
    }
  }, [_vm._v("“Any women on the staff of this respectable men-only club?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00009"
    }
  }, [_vm._v("“That’s why I’m calling you. Their recreation officer has signed up these broads to put on sexy floor shows. But they’re amateurs and nobody in the place understands real showbusiness so the manager has contacted me. I’ve told him I’ll find a professional to rehearse these girls for five or six weeks and get them performing some real smooth routines.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00036"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00005"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("7"), _c('span', {
    staticClass: "sc"
  }, [_vm._v(" WHY I NEED AMERICA ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00010"
    }
  }, [_vm._v("“What’s he paying?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00011"
    }
  }, [_vm._v("Charlie tells her. She says, “But … I mean, for money like that they can get anybody! Somebody famous, I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00012"
    }
  }, [_vm._v("“Honey, they want someone efficient who won’t draw attention to them. Remember those wives and kids; I have told them I might get them the director of "), _c('i', [_vm._v("Caught in Barbed")]), _vm._v(" "), _c('i', [_vm._v("Wire")]), _vm._v(", and that she’s a very discreet lady.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00013"
    }
  }, [_vm._v("“But I never directed –”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00014"
    }
  }, [_vm._v("“Of course you never directed it but they don’t know that. The director’s name didn’t appear on the credits because there are no credits. Come to the office at three this afternoon and meet the club manager. If he likes you he’ll take you to look the place over.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00015"
    }
  }, [_vm._v("“Hm … How should I dress for him?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00016"
    }
  }, [_vm._v("He tells her. She says, “No professional director dresses like that!”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00017"
    }
  }, [_vm._v("“Honey, I told you, these guys know nothing about showbiz. Dress like that and they’ll be too busy looking to ask questions.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00018"
    }
  }, [_vm._v("“The set-up stinks, Charlie.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00019"
    }
  }, [_vm._v("“Don’t worry, Janine, I’ll find someone else,” and he hangs up. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00005"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Broads. Real smooth routines. Honey. This set-up stinks. These people are American. Years out of date, perhaps, but American. I can’t help it. Seen from Selkirk America is a land of endless pornographic possibility. Is that because it’s the world’s richest nation? No. There is less poverty and more sexual freedom in Scandinavia and Holland. It’s because my most precious fantasies have been American, from Cowboys and Indians and Tarzan till … "), _c('i', [_vm._v("The Dirty")]), _vm._v(" "), _c('i', [_vm._v("Dozen? Apocalypse Now")]), _vm._v("? I forget when I stopped needing new ones.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00020"
    }
  }, [_vm._v("“Don’t worry, Janine, I’ll find someone else,” and he hangs up. She dials back at once but the line is engaged. She dials repeatedly for three minutes and gets him at last. She says, “Charlie, I said the set-up stinks, but that doesn’t mean I’m not interested. For money like that of course I’m interested!”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00021"
    }
  }, [_vm._v("“Glad to hear it. You’re in luck. I’ve been trying to get Wanda Neuman but she’s out. All right, be here at eleven.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00038"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00006"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("8 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("CLOTHES THAT ARE BONDAGE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00022"
    }
  }, [_vm._v("“Charlie, you mentioned a millionaire.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00023"
    }
  }, [_vm._v("“That’s right. The club has a couple of them, so dress like I said.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00024"
    }
  }, [_vm._v("“What do they call this club?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00025"
    }
  }, [_vm._v("But again he has hung up. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00006"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four hours later Janine is worried and trying not to show it but her voice is husky when she says, “My agent told me to dress this way.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00026"
    }
  }, [_vm._v("“Your agent reads Hollis like a book.”")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("But Janine is not (here come the clothes) happy with the white silk shirt shaped by the way it hangs from her etcetera I mean BREASTS, silk shirt not quite reaching the thick harness-leather belt which is not holding up the miniskirt but hangs in the loops round the waistband of the white suede miniskirt supported by her hips and unbuttoned as high as the top of the black fishnet stockings whose mesh is wide enough to insert three fingers I HATED clothes when I was young. My mother made me wear far too many of them, mostly jackets and coats. When I complained that I was too hot she said the weather could change any moment and "), _c('i', [_vm._v("she")]), _vm._v(" wasn’t going to have me off school with a bad cold. I had three classes of suit. The best suit, the newest, was for Sunday and for visiting relations. The second-best suit was for going to school. The third was for “playing rough games”. Yes, she expected me to play games, but I had to come home and change into my oldest suit first, and that was often too small to run about in comfortably. Of course when you’re a child most games happen on the way home from school or in the playground, so this clothing programme reduced my social opportunities. We lived in a mining town where a lot of boys wore dungarees to school and could play when they liked. I envied them. In summertime some of them didn’t even go home after school but rambled in gangs through the surrounding country, fishing and tree climbing, getting into trouble with farmers and coming home at sunset to grab their own supper of bread and cheese. Their mothers (my mother thought) didn’t look after them properly. When the evening meal was finished and my father had gone out to a union meeting (he was a timekeeper at the pithead, a strong union man) I would start ")]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("changing into my oldest suit and my mother would say, ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00007"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("9 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("HOME MOTHER JANE RUSSELL")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00028"
    }
  }, [_vm._v("“Have you done your homework yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00029"
    }
  }, [_vm._v("“No. I’ll do it when I get back.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00030"
    }
  }, [_vm._v("“Why not do it now, while you’re still fresh?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00031"
    }
  }, [_vm._v("“The sun’s shining, it’s a nice evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00032"
    }
  }, [_vm._v("“So you’re determined to hew coal when you grow up?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00033"
    }
  }, [_vm._v("“No. But it’s a nice evening.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00034"
    }
  }, [_vm._v("“Hm!”")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00035"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("And she would fall silent. Her silences were very heavy. I could never pull myself from under them. I could never leave her alone in one, that would have been cruel. Drearily I would get out the school books and spread them on the kitchen table. She would sit by the fire with a piece of knitting or sewing and we would be busy on opposite sides of the room. The wireless would be playing very quietly (“and now the strains of "), _c('i', [_vm._v("Kate Dalrymple")]), _vm._v(" introduce Jimmy Shand and his band with thirty minutes of Scottish country dance music”). The room would grow lighter. Later she would brew a pot of tea and quietly lay on the table beside me a milked and sweetened cup of it with a chocolate biscuit in the saucer. Without lifting my eyes from the books I would grunt to show that I could not be so easily soothed, but inside I was perfectly happy. My happiest moments were passed with that woman. She kept me indoors but she never interfered with my mind. Between the pages of a book I had a newspaper clipping to carry my thoughts miles and miles away, an advert for "), _c('i', [_vm._v("The Outlaw")]), _vm._v(" – MEAN! MOODY! MAGNIFICENT! above a photograph of Jane Russell, her blouse pulled off both shoulders, leaning back against some straw glaring at me with this inviting defiance. My feelings were more than sexual. I felt grateful. I was amazed by myself. Nobody else, I realized, knew all the rich things I knew. The clean tidy room, the click of my mother’s needles, Jane Russell’s soft shoulders and sulky mouth, the evening sunlight over the town in the bend of the river where the colliers’ sons were guddling trout, a mushroom cloud in the Pacific sky above Bikini atoll, Jimmy Shand’s music and the taste of a chocolate biscuit were precisely held by "), _c('i', [_vm._v("my")]), _vm._v(" mind and by nobody else’s. I was vast. I was sure that one day I would do anything in the world I wanted. I thought it likely that I would ")]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("marry Jane Russell. I was ten or twelve at the time and believed sex and marriage were nearly the same thing. Now I am almost fiforget that forget that forget that where did I leave Janine? ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00008"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("10 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("JANINE NEARING THE COUNTRY CLUB")])])])]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00007"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a fast car trying not to be afraid, her vulnerable breasts in a white silk shirt, accessible arse in a leather miniskirt, shapely thighs legs feet in black fishnet stockings and, ah! white open-topped shoes with stiletto heels. Standing up in them Janine is on tiptoe, she must raise and tighten her bum, press back her shoulders, lift her chin. Each shoe is tied on by three slender white thongs with small gold buckles which fasten straight across the toes, diagonally over the arch of the foot, and encircle the ankle so that (how happy I am) if the car slows or stops she can’t slip them off, fling open the door and run. The car does slow, a little, leaving the freeway for a sideroad through a plantation of fir trees which cast a very cold shadow. “Nearly home!” says Max happily. The car stops before a tall gate in a security fence. Through the wires Janine can see a gatehouse and a patch of sunlight where a man in shorts, singlet and peaked cap is dozing in a deckchair. Max sounds his horn. The man stands, peers towards the car, salutes Max and enters the gatehouse.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00036"
    }
  }, [_vm._v("“What kind of country-club is "), _c('i', [_vm._v("this")]), _vm._v("?” asks Janine, staring at a board on the gate. It carries the name of a government district and FORENSIC RESEARCH ASSOCIATION. TRESPASSERS WILL BE PROSECUTED. GUARD DOGS. DANGER.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00037"
    }
  }, [_vm._v("“The rich kind,” say Max. “Our members are mostly lawyers and policemen, so for tax-avoidance purposes we pretend we are doing something useful.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00038"
    }
  }, [_vm._v("“Neat!” says Janine, smiling for the first time that day. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00008"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("The gate clicks and swings inward. The car passes the gatehouse and emerges from the trees on to an unfenced road curving over a golf-course. Tiny figures move on a distant green beside a white building with windows glittering in the afternoon sun. This is all so securely and expensively what Janine wants that she gives a little sigh of relief thinking, ‘I’m an actress so I can’t help imagining things. ")]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("Max, the lout, is excited, the lout, because I’m sexy, but that’s natural, it needn’t have bothered me. Did I sweat?’  She takes a powder-compact from her handbag, gives her face a straight professional look in the mirror and puts it away thinking: nothing wrong there. Max chuckles. ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00009"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("11 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("FEELING REASSURED")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00039"
    }
  }, [_vm._v("“Admit,” he says, “back there you thought I was a rapist white slaver, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00040"
    }
  }, [_vm._v("“Well, you said this place was just outside town. And well, it just isn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00041"
    }
  }, [_vm._v("“I’m a bad judge of distance because my work demands that I travel a lot.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00042"
    }
  }, [_vm._v("But Janine is not interested in Max and his work. She says,")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00043"
    }
  }, [_vm._v("“How many members has your club?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00044"
    }
  }, [_vm._v("“Twelve.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00045"
    }
  }, [_vm._v("“Twelve? But … I mean …”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00046"
    }
  }, [_vm._v("“Ridiculous isn’t it? Our staff outnumber us nearly five to one. But we like it that way. We can afford it.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00047"
    }
  }, [_vm._v("The thought of such wealth makes Janine feel almost dizzy. The car stops on a bed of granite chips before some wide white steps. Max, quick on his feet, gets out and opens the door on her side wanting to take her arm, but Janine ignores him for now she is pleased with her shoes. Not many women could climb steps with dignity in nine-inch high heels. Janine does it, and when the glass doors at the top open automatically she steps firmly on to the blue carpet of the club foyer feeling she deserves a round of applause. Which is perhaps why the man walking toward her affects her like a round of applause. He is stout (not fat like Max) and soberly and expensively dressed, and he smiles at her, not in a boyish lecherous way (like Max) but with the mature admiration of someone who appreciates her exactly as she appreciates herself. He shakes her hand saying quietly,")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00048"
    }
  }, [_vm._v("“Miss Janine Crystal.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00049"
    }
  }, [_vm._v("She says, “Mr Hollis?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00050"
    }
  }, [_vm._v("Max laughs loudly and shouts, “Oh no, this is our president, Bill Stroud.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00051"
    }
  }, [_vm._v("Stroud says, “Our recreation officer is not quite ready for you. I would like to discuss your salary and answer questions before you meet Hollis. But first of all, drinks and lunch perhaps? Do you wish to visit a washroom?”")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("“Thanks, but I’m fine. And yes, I’d like lunch, if that’s all ")]), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_vm._v("right. And … wow. I mean wow, this place is something special.” ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }, [_c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00009"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00010"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("12 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("OPULENT DECOR")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another glass door has opened and they are crossing stop. Stop. I want rid of Max. Stroud says, “Max, you laugh too loud, you have enjoyed Miss Crystal’s company enough for today. I am sure you can find someone to entertain you in the gymnasium.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00053"
    }
  }, [_vm._v("Max’s face goes expressionless. With a slight nod to Janine he walks quickly away. In the gymnasium Big Momma stands with no no no no no shortcuts. Take the long way round. I may be awake for hours. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00010"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Another glass door has opened and they (Stroud and Janine) are crossing the soft green carpet of a circular room which seems open to the sky, for the glass ceiling is only slightly tinted to soften the glare of the sun. There are low coffee-tables with magazines and armchairs, and to one side some small restaurant tables. A section of wall is a cocktail bar where a man on a high stool chats to a waitress. Elsewhere the room seems walled with palm trees and tall grasses which lean out over the carpet, and when Janine sits down with Stroud at a table set with cutlery for two she notices the door is hidden by greenery. She thinks, ‘This is like a dream. I feel I’m sitting in a jungle.’ Why the hell does Janine need all this interior decoration? I don’t need it. I’m expected to stay in first-class hotels when I travel but I always choose small family places like this. I don’t save money that way, my firm pays the bills, but I feel more at home in small hotels. Years ago in London a client took me for a business lunch in the Athenaeum, or was it the Reform Club? Anyway, there were chandeliers, marble pillars, real leather armchairs, a dome (I think) and waiters in evening dress. I acted perfectly calmly but inside I was hard, watchful, critical. Janine is also acting calmly but inside she has been warmed and softened by this luxury, she really loves it and I despise her for that. No I don’t, but I would like to. She has no right to enjoy things I can’t. She says aloud,")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00054"
    }
  }, [_vm._v("“This is like a dream. I feel I’m sitting in a jungle.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00055"
    }
  }, [_vm._v("“A comfortable jungle,” says Stroud handing her a menu.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00056"
    }
  }, [_vm._v("“Not all parts of the club are so comfortable.” ")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  })]), _c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("13 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MOTHER’S FRIENDS")])])])])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("The menu is in French. She hands it back saying sweetly, “Please choose for both of us. I like anything that’s nice.” ")])]), _c('p', {
    staticClass: "fp"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("Stroud says, “Suppose we begin with–” ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00057"
    }
  }, [_vm._v("I don’t know French. Why quote what Stroud says? I’m losing interest. Drink. Think. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00011"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What did my mother think as we sat on opposite sides of the kitchen, and she knitted and I mixed profit-and-loss arithmetic with a stormy wooing of Jane Russell? I’ve never wondered what happened in her head before. She was a tall, rather quiet woman. All the neighbours trusted her, even those who disliked each other. She had a sharp sense of humour but listened carefully to what they said and seldom passed it on. While I was working and brooding near her my feelings of harmony, of luxury, were sometimes so strong that I am now nearly certain she was deliberately putting dreams into my head, dreams of power and possessions and far-ranging life. She managed her own life perfectly, as far as I could see, but didn’t enjoy it much. Why do I think that? She only spoke to me about my homework and what clothes to wear. Except one Friday afternoon when I came home from school and she was at the door saying cheerful goodbyes to her closest friends, five women I had called “Auntie” when I was younger. They were leaving one of the gossipy little tea-and-biscuit parties women kept giving each other in those days. She was more silent than usual as she cleared away the cups, then suddenly muttered in a low, fierce voice, “I hate bloody women.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00058"
    }
  }, [_vm._v("I was astonished. I said, “Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00059"
    }
  }, [_vm._v("“Have you ever heard them talk?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00060"
    }
  }, [_vm._v("I didn’t answer. Since I was a baby I had heard them talk about their children, husbands, recipes, dress patterns and love-stories in the "), _c('i', [_vm._v("Woman’s Own ")]), _vm._v("and"), _c('i', [_vm._v(" People’s Friend")]), _vm._v(". What they said never interested me, but the noise of it was a comforting background music which I liked much more than male talk about sport and politics, which made a snapping, argumentative, menacing noise. But that was the only time I noticed my mother was not completely satisfied, before she oh forget it forget it forget it. ")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00012"
    }
  }, [_c('p', {
    staticClass: "fp"
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_13"
    }
  }, [_vm._v("I know now that what was wrong with her was too much ")]), _c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("energy and intelligence. Cleaning a room and kitchen, serving a husband and son, entertaining the neighbours did not use her up. I doubt if working in a shop, or as a secretary, would have used her up either. Or travelling around supervising the installation of security systems, like I do. A lot of nonsense is talked nowadays about “job satisfaction”, as if many people could have it. The things which make most jobs bearable (not satisfying – just bearable) are extra, intoxicating ingredients like: pop music on a loudspeaker, a pay-cheque, hope of promotion, hope of a wild night of love. I take straight alcohol, which has started working again. My two heads are beginning to hum to each other, above and below. Good Penis! Good Doggie! Are you awake? ")])]), _c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00012"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("14 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("TWO HEADS SELF-HATRED")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00061"
    }
  }, [_vm._v("– Yes master.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00062"
    }
  }, [_vm._v("Will you sit up and beg for meat again?")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00063"
    }
  }, [_vm._v("– Yes! If you show me something tasty.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00064"
    }
  }, [_vm._v("Stroud signals to the waitress at the cocktail bar, a tall blonde who approaches in a languorous amble which emphasises the movement of her hips.")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00013"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tall blonde waitress must amble because her skirt won’t let her walk any other way. It is a button-through white satin (no) white denim (no) white suede (yes) like Janine’s, but longer, and so tight that although half unfastened her knees appear through the slit in front slowly, one after the other, and Janine can hear the soft rasp of her thighs pressing past each other, but it is not the skirt that strikes Janine with confusion. She thinks, “Silk blouse, net stockings, white high heels exactly like mine, yes even her mouth and eyes are made up just like mine, that’s why she’s staring at me that way. God, I hate these frigid bitches who dress like whores and then stare at me as if I was dirt.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00047"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_14"
    }
  }, [_vm._v("But now the waitress takes pad and pencil from her waistband and attends completely to Stroud ordering the meal, and in spite of the girl’s height and hair-colour Janine’s feeling that she is watching "), _c('i', [_vm._v("herself")]), _vm._v(" increases, filling her with a numb, dreamy excitement. The excitement has a spice of fear in it but not much. If you wake late for work one morning, spring from bed, dress quickly, then rushing to the front door find it blocked by your car standing in the ")]), _c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("middle of the living-room, the furniture moved back against the walls; if you discover this you will not feel afraid at first,  you will think that you have not really wakened at all. And when a careful examination shows the car as solid as usual, and undoubtedly your own, because your key opens the door, and if you find the room solid too, with the wallpaper pattern undisturbed, making it unlikely that a jocular friend has suddenly become a millionaire and hired a team of expert workmen silently to knock a hole, insert the car, then swiftly reconstruct the wall exactly as it was – if the consistency of things shows you are in a world like the usual, apart from one inexplicable oddity – then only a pessimist will return to bed hoping to fall asleep and wake again in the usual world he understands. I would walk round the car, open the door and adventure out, fearful, of course, like all explorers in a strange world, but hoping for something new and better. I would have to see everything as a child does, letting the things themselves teach me what they were, knowing my grasp of them was secondary and slight. Why am I diluting an enjoyable wicked fantasy with this sort of crap? – like a publisher attaching a brainy little essay by a French critic to "), _c('i', [_vm._v("The Story of O")]), _vm._v(" to make the porn-eaters think they are in first-class intellectual company. How the waitress is dressed gives Janine a queer dreamy feeling, that’s all I meant to say, Janine can’t stop staring and when she ambles away Stroud chuckles and says, “She hates you.”")])]), _c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00013"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("15 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("MIRACULOUS MOTOR-CAR ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00065"
    }
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00066"
    }
  }, [_vm._v("“Jealousy. You’re dressed like one of the staff but she’s got to serve you as if you were a member.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00067"
    }
  }, [_vm._v("“My agent told me to dress like this.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00068"
    }
  }, [_vm._v("“He did? A pity. I thought you were delicately indicating that you wished to work here. I was pleased.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00069"
    }
  }, [_vm._v("Janine notices a small plump quick waitress serving a man at a nearby table. The waitress can move quickly because her skirt is unbuttoned almost to the waistband. Stroud says,")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00070"
    }
  }, [_vm._v("“All our waitresses and new girls dress like that. Hollis is something of a button-freak.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00071"
    }
  }, [_vm._v("“Do Mr Hollis’s preferences have to interest me?”")])]), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00072"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_15"
    }
  }, [_vm._v("Stroud takes an envelope from his pocket and lays it on the table between them. He says, “Perhaps the time has come to talk about money. Would you open this and count what’s ")]), _c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_vm._v("inside? If you join us it will be your first week’s salary. If you decide to leave now it will be compensation for your trouble.”")])]), _c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00014"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("16 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("JANINE TAKES THE  BAIT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00073"
    }
  }, [_vm._v("Janine hesitates then takes from the envelope a flat wad of clean new notes and counts them. The money is more than her agent suggested, more than Janine imagined possible. She knows Stroud is watching her closely. She thinks, ‘If I was a cat I would lick my lips, but I’m an actress, and smart. There must be several millionaires in this club if they’ll pay this money to get a girl like me on their books.’")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00074"
    }
  }, [_vm._v("She puts the notes back in the envelope and snaps it into her handbag saying, “I don’t mind taking a friendly interest in Mr Hollis’s preferences, if that’s what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00075"
    }
  }, [_vm._v("Stroud smiles and says, “Then he’ll be glad to see you any time.”")]), _vm._v(" "), _c('div', {
    staticClass: "paras leading-line",
    attrs: {
      "id": "rw-paras-leading-line_84072-00014"
    }
  }, [_c('p', {
    staticClass: "fp"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And I have placed this last bit of dialogue very carefully. Later, when Janine is trapped and trying to escape, she will remember that she was given a chance to leave and refused because of money. We all have a moment when the road forks and we take the wrong turning. Mine was when Helen told me she was pregnant and I said I needed a week and later the doorbell rang and, forget it, I opened the door and Mr Hume and his two sons walked straight past me and, forget it, stood in the middle of my own room, yes, my own room and FORGET IT. FORGET IT.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00076"
    }
  }, [_vm._v("“Do Mr Hollis’s preferences need to interest me?”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00077"
    }
  }, [_vm._v("The money. Count. Hide licklip. Look cool.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00078"
    }
  }, [_vm._v("“I’ll be glad to take a friendly interest in Mr Hollis’s preferences, if that’s what you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00079"
    }
  }, [_vm._v("The meal, then audition time, and Stroud is ushering her along a softly lit brown-carpeted corridor to a door marked "), _c('i', [_vm._v("recreation room")]), _vm._v(" which he opens, standing aside to let her through, and entering she is dazzled by lights from low down shining straight into her face. She senses a wide dim space on each side, a desk ahead with one or two people silhouetted against the white sources of the light, a continuous purring noise, perhaps a film projector? She looks back to the door as it shuts with a double click. No Stroud. A voice cries, “Come on in, Miss Crystal, show us how you can walk.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_84072-00049"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_16"
    }
  }), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  }, [_c('div', {
    staticClass: "block sidebar floatgalley-outside",
    attrs: {
      "id": "rw-block-sidebar_84072-00015"
    }
  }, [_c('div', {
    staticClass: "pc"
  }, [_c('p', [_vm._v("17 "), _c('span', {
    staticClass: "sc"
  }, [_vm._v("THE TRAP SHUTS TIGHT")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00080"
    }
  }, [_vm._v("Heart thudding, eyes narrowed to slits against the glare she  walks slowly toward the light thinking, ‘Act calm. I felt  like this in the car with Max, and with Stroud when I saw  the waitress, but I acted calm and it was all right.’")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00081"
    }
  }, [_vm._v("She hears two unfastened studs of her skirt click with each step she takes.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00082"
    }
  }, [_vm._v("“That’s a sexy sound,” the voice says, and giggles.")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00083"
    }
  }, [_vm._v("‘Keep cool,’ thinks Janine. ‘Pretend this is an ordinary audition.’")]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_84072-00084"
    }
  }, [_vm._v("End of first part.")])])]), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_17"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9b49d44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847674449_chapter_01.vue
// module id = 78
// module chunks = 0